import { atom } from "jotai";
export const pathNameAtom = atom("");
